import { ChevronLeftIcon } from '@langchain/untitled-ui-icons';

import { useParams } from 'react-router-dom';

import { Breadcrumb } from '@/components/Breadcrumbs';
import { useRun } from '@/hooks/useSwr';
import {
  appPublicDatasetsPath,
  appPublicPath,
  appRunPath,
  appSessionPath,
} from '@/utils/constants';

export function PublicDatasetRunPlaygroundCrumb() {
  const { datasetShareToken, sessionId, runId } = useParams();
  const publicRun = useRun({
    id: runId,
    shareToken: { datasetShareToken },
  });

  const run = publicRun.data;
  if (run == null) return null;

  const pathBack = `/${appPublicPath}/${datasetShareToken}/${appPublicDatasetsPath}/${sessionId}/${appSessionPath}/${appRunPath}/${runId}`;

  return (
    <Breadcrumb
      path={pathBack}
      name={`Back to ${run.name} Run`}
      icon={
        <ChevronLeftIcon
          className="size-4"
          sx={{
            marginLeft: 0,
            w: 4,
            h: 4,
            color: 'neutral.400',
          }}
        />
      }
      isFirst
    />
  );
}
